import React from "react";
import Layout from "../components/Layout";
import "./Login.css";
import facebook from "../assets/images/facebook.svg";
import google from "../assets/images/google.svg";
import {useState} from 'react'
import {useHistory} from 'react-router-dom'
import { useUserAuth } from "../context/UserAuthContext";
import { doc, setDoc, updateDoc } from "firebase/firestore"; 
import {db } from "../FirebaseConfig";
import Loading from "../components/Loading";
export default function Login() {
  const dataForm = [{id:"0111",title:"Login",type:"login"},{id:"0112",title:"Sign up",type:"signUp"}]
  const [form,getForm] = useState("login")
  const handlerClick =(item)=>{
    getForm(item.type)
  }
  return (
    <Layout>
      <div className="login-container" style={{color:"rgb(69,69,69"}}>
        <div className="login-text">
          <h2 style={{ margin: "auto", textAlign: "center", fontSize: "30px" ,color:"rgb(69,69,69"}}>
            Login with your Account
          </h2>
          <p>or create a new account for free</p>
        </div>
        <div className="login-form">
          <div>
            <ul>
              {dataForm.map(item=>{
                return <li key={item.id} onClick={()=>handlerClick(item)} className={item.type===form ? "active-login" :""}><em>{item.title}</em></li>
              })}
            </ul>
          </div>
          <div className="login-btn">
            <button>
              <img
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "4px",
                  marginLeft: "30px",
                }}
                src={facebook}
                alt="#"
              />
              Continue with Facebook
            </button>
            <button>
              <img
                style={{
                  width: "20px",
                  height: "20px",
                  marginRight: "4px",
                  marginLeft: "30px",
                }}
                src={google}
                alt="#"
              />
              Continue with Google
            </button>
          </div>
          <div
            className="text-break"
            style={{
              textAlign: "center",
              position: "relative",
              overflow: "hidden",
              width: "80%"
            }}
          >
            or
          </div>
          {form === "login" ? <LoginForm/> : <SignUpForm/>}
        </div>
        
      </div>
    </Layout>
  );
}

const LoginForm = () => {
  const [loading,SetLoading] = useState(false)
  const [email,setEmail] = useState("")
  const [password,setPassword] = useState("")
  const history = useHistory()
  const { logIn,setLoginInfo, } = useUserAuth();
  // email==="thorpham@gmail.com" && password==="123456"
  const handleLoginForm = async (e)=>{
    e.preventDefault()
    SetLoading(true)
    try{
      await logIn(email, password);
      history.push("/")
      setLoginInfo(true)
      setEmail("")
      setPassword("")
    }catch(e){
      alert(e.message)
      // console.log(e.message)
    }
    SetLoading(false)
    
  }
  return (
    <div className="login-email">
      <input type="email" placeholder="Email"  onChange={(e)=>setEmail(e.target.value)}></input>

      <input type="password" placeholder="Password"  onChange={(e)=>setPassword(e.target.value)}></input>

      <label class="container-checkbox">
        <input
          type="checkbox"
          style={{ width: "15px", marginRight: "3px" }}
        />
        Remeber me
      </label>
      <button
        style={{
          width: "120px",
          height: "40px",
          color: "#fff",
          cursor: "pointer",
          backgroundColor: "rgb(38, 153, 251)",
          border: "none",
          fontWeight: "bold",
          borderRadius: "3px",
          letterSpacing: "1px",
        }}

        onClick={handleLoginForm}
      >
        Login
      </button>
      {loading && <Loading />}
    </div>
  );
};


const SignUpForm = ()=>{
  const [loading,SetLoading] = useState(false)
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { signUp,setLoginInfo } = useUserAuth();
  const history = useHistory()
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newUser = doc(db, "users", email);
    setError("");
    SetLoading(true)
    if(password !== confirmPassword){
      alert("Password not match");
    }
    try {
      await signUp(email, password);
      await setDoc(newUser, {
        username: email,
        srcImgPaths: [],
    });
      history.push("/")
      setLoginInfo(true)
    } catch (err) {
      setError(err.message);
    }
    SetLoading(false)
  };
  return  <div className="signup-form">
  {loading && <Loading />}
  <div>
    <label >Email</label>
    <input type="email" placeholder="Email" onChange={(e)=>setEmail(e.target.value)}></input>
  </div>
  <div>
    <label>Password (6 characters minimum)</label>
    <input type="password" placeholder="Password" onChange={(e)=>setPassword(e.target.value)}></input>
  </div>
  <div>
    <label>Password confirmation</label>
    <input type="password" placeholder="Password" onChange={(e)=>setConfirmPassword(e.target.value)}></input>
  </div>
  <div className="sign-bottom">
  <input
      type="checkbox"
      style={{ width: "15px", marginRight: "3px" }}
    />
  <label >  I agree to the Terms </label>
    
  
  </div>
  <button
    style={{
      width: "120px",
      height: "40px",
      color: "#fff",
      cursor: "pointer",
      backgroundColor: "rgb(38, 153, 251)",
      border: "none",
      fontWeight: "bold",
      borderRadius: "3px",
      letterSpacing: "1px",
      marginBottom:"1rem"
    }}
    onClick={handleSubmit}
  >
    Register
  </button>
  
</div>
}